import { api } from '@/lib/api';
import type {
  WebsiteResponse,
  CreateWebsiteRequest,
  UpdateWebsiteRequest,
  WebsiteQuery,
  TemplateModel,
} from '@troia-v3/types';

interface WebsiteListResponse {
  items: WebsiteResponse[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const websitesApi = {
  // ============================================================================
  // CRUD
  // ============================================================================

  async getWebsites(query?: WebsiteQuery): Promise<WebsiteListResponse> {
    const response = await api.get('websites', { params: query });
    return response.data.data;
  },

  async getWebsiteById(id: string): Promise<WebsiteResponse> {
    const response = await api.get(`websites/${id}`);
    return response.data.data;
  },

  async createWebsite(data: CreateWebsiteRequest): Promise<WebsiteResponse> {
    const response = await api.post('websites', data);
    return response.data.data;
  },

  async updateWebsite(id: string, data: UpdateWebsiteRequest): Promise<WebsiteResponse> {
    const response = await api.put(`websites/${id}`, data);
    return response.data.data;
  },

  async deleteWebsite(id: string): Promise<void> {
    await api.delete(`websites/${id}`);
  },

  // ============================================================================
  // PUBLISH / UNPUBLISH
  // ============================================================================

  async publishWebsite(id: string): Promise<WebsiteResponse> {
    const response = await api.post(`websites/${id}/publish`);
    return response.data.data;
  },

  async unpublishWebsite(id: string): Promise<WebsiteResponse> {
    const response = await api.post(`websites/${id}/unpublish`);
    return response.data.data;
  },

  // ============================================================================
  // MODEL REGISTRY
  // ============================================================================

  async getModels(): Promise<TemplateModel[]> {
    const response = await api.get('websites/models');
    return response.data.data;
  },

  async getModel(modelId: string): Promise<TemplateModel> {
    const response = await api.get(`websites/models/${modelId}`);
    return response.data.data;
  },
};
